import { Injectable } from '@angular/core';
import { CrossStudyPortalAppConfig } from 'projects/cross-study-portal-lib/src/lib/interfaces/app-config';
import { AppConfigLoaderService, AppPaths } from 'projects/cross-study-portal-lib/src/public-api';
import { AsyncSubject, Observable } from 'rxjs';
import { concatMap, tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class ContextInitializerService<T> {
  private context: AsyncSubject<T> = new AsyncSubject();
  isInitialized = false;

  initContext(appConfig: AppConfigLoaderService<CrossStudyPortalAppConfig>, config: AppPaths) {
    this.context.subscribe({
      next: _ => _,
      error: () => console.error('Failed to load Context'),
    });

    const context$ = appConfig.getConfig$().pipe(
      concatMap(_ => {
        const contextPath = `${_.apiUrl}${config.getControllerPaths().contextApiPath}`;
        // using fetch to avoid interceptors
        return fetch(contextPath, { credentials: 'include' });
      }),
      tap(
        async response => {
          if (!response.ok) {
            return response;
          }

          const context = await response.clone().json();
          this.context.next(context);
          this.context.complete();
          this.isInitialized = true;

          return context;
        }));

    return context$.toPromise();
  }

  getContext$(): Observable<T> {
    return this.context.asObservable();
  }
}
